import { IDS_URL, isBrowser } from "appConfiguration";

const URLClass = isBrowser ? URL : require("url").URL;

export function getAuthUrl(path: string) {
  const { href } = new URLClass(path, IDS_URL);
  return href;
}
